/**
 * Texts for User Training page
 */
export const userTrainingPageText = {
    title: 'Formação para utilizadores - CamAPS FX',
    titleMeta: 'Recursos de formação abrangentes para utilizadores do CamAPS FX',
    descriptionMeta: 'Aceda a materiais de formação completos, tutoriais em vídeo, guias do utilizador e webinars para tirar o máximo partido do CamAPS FX.',
    keywords:
        'formação camaps fx, formação camaps, formação diabetes, formação bomba de insulina, guia do utilizador, tutoriais em vídeo, ' +
        'formação cgm, formação administração automática de insulina, educação diabetes tipo 1',
    localeMeta: 'pt_PT',

    mainHeader: 'Formação para utilizadores',
    mainSubHeader: 'Conclua a formação essencial na aplicação antes de utilizar a aplicação CamAPS FX.',

    gettingStartedHeader: 'Primeiros passos',
    step1Title: '<strong>Passo 1:</strong><br/>Descarregue a aplicação',
    step2Title: '<strong>Passo 2:</strong><br/>Crie uma conta',
    step3Title: '<strong>Passo 3:</strong><br/>Inicie a formação essencial na aplicação',
    step4Title: '<strong>Passo 4:</strong><br/>Emparelhe a bomba e o CGM escolhidos (com a aprovação da sua equipa de diabetes) ou explore a aplicação com o <strong>Modo virtual</strong>',
    videoSrc: '/video/In-app training loop_1.mp4', // Path to video in public folder

    supportSectionTitle: 'Precisa de ajuda para instalar a aplicação?',
    supportSectionText: 'Visite a nossa secção de apoio para obter orientações',
    supportButtonText: 'APOIO',
    findOutMoreButtonText: 'SAIBA MAIS',

    additionalResourcesTitle: 'Recursos adicionais',
    additionalResourcesSubtitle: 'Aprenda através de guias visuais passo a passo ou assista a sessões orientadas por especialistas sobre a utilização da aplicação.',
    
    animationsTitle: 'Animações',
    animationsDescription: 'Estas animações curtas foram concebidas para responder a algumas das perguntas mais frequentes sobre o CamAPS FX.',
    animationsLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    
    webinarsTitle: 'Webinars',
    webinarsDescription: 'Estes webinars são úteis para pessoas com diabetes tipo 1, as suas famílias e cuidadores, bem como para professores, pessoal de apoio educativo e profissionais de saúde. São disponibilizados em inglês.',
    webinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    factsheetsTitle: 'Fichas informativas',
    factsheetsDescription: 'Esta série de fichas informativas foi concebida como um conjunto de guias introdutórios. Não substituem o aconselhamento médico nem o apoio da equipa de diabetes da pessoa.',
    factsheetsLink: 'https://www.camdiabtraining.com',

    inAppTrainingHeader: 'Formação na aplicação',
    inAppTrainingText: 'Comece pela formação essencial integrada na aplicação CamAPS FX. Esta formação interativa irá guiá-lo através de todas as funcionalidades essenciais que precisa de conhecer.<br/><br/><strong>Para aceder:</strong> Descarregue a aplicação CamAPS FX e crie uma conta para iniciar o seu percurso de formação na aplicação.',

    gettingStartedText: '<strong>Passo 1:</strong> Descarregue a aplicação CamAPS FX a partir da loja de aplicações do seu dispositivo<br/><strong>Passo 2:</strong> Crie a sua conta<br/><strong>Passo 3:</strong> Conclua os módulos de formação na aplicação<br/><strong>Passo 4:</strong> Ligue a sua bomba de insulina e o CGM<br/><strong>Passo 5:</strong> Inicie o seu percurso com o CamAPS FX',

    trainingResourcesHeader: 'Recursos de formação adicionais',
    videoTutorialsText: 'Tutoriais em vídeo',
    videoTutorialsDesc: 'Assista a guias em vídeo passo a passo sobre configuração, utilização diária e resolução de problemas.',
    videoTutorialsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    userGuidesText: 'Guias do utilizador e documentação',
    userGuidesDesc: 'Descarregue guias PDF abrangentes e materiais de referência rápida.',
    userGuidesLink: 'https://www.camdiabtraining.com',
    
    webinarsText: 'Webinars em direto',
    webinarsDesc: 'Participe em sessões de formação orientadas por especialistas e oportunidades de perguntas e respostas.',

    needHelpHeader: 'Precisa de ajuda?',
    needHelpTextStart: 'Se precisar de assistência ou tiver questões, visite a nossa página de',
    supportLinkText: 'Apoio',
    needHelpTextEnd: 'para obter ajuda adicional e dados de contacto.'
};
